
import template from "./bSideBar.html";

export function bSideBarDirective() {
  'ngInject';

  let directive= {
    restrict: 'E',
    template: template,
    controller: bSideBarController,
    controllerAs: 'bSideBar',
    scope: {
      config: "=",
      user: "=?"
    },
    bindToController: true
  };

  return directive;
}

class bSideBarController {
  constructor($location, Auth) {
    'ngInject';

    this.$location = $location;
    this.Auth = Auth;

    this.path = this.$location.path().split('/');

    this.showSideBar();

    document.querySelector('[ng-view]').firstChild.firstChild.style.transition = "margin-left 0.7s";

    this.Auth.authorizeAdmin().then(() => {
      this.Auth.getFeatureFlags().then((ff) => {
        this.featureFlags = ff.data;
        this.publicApiFeatureFlag = !!this.featureFlags.find(f => f == "PublicApi");
      });
    });

  }

  showSideBar() {
    this.adminSideBarVisible = true;
    document.querySelector('[ng-view]').firstChild.firstChild.style.marginLeft = "350px";
  }

  hideSideBar() {
    this.adminSideBarVisible = false;
    document.querySelector('[ng-view]').firstChild.firstChild.style.marginLeft = "0";
  }
}
